import { useUserStore } from '@/store';

export const normalizePermissions = (permissions) => {
  if (!Array.isArray(permissions)) return [];
  return [...new Set(permissions.filter(Boolean))];
};

export const hasPermission = (code) => {
  if (!code) return true;
  const userStore = useUserStore();
  const permissions = normalizePermissions(userStore.userInfo?.permissions || userStore.userInfo?.roles || []);
  return permissions.includes('all') || permissions.includes(code);
};

export const setupPermissionDirective = (app) => {
  app.directive('permission', {
    mounted(el, binding) {
      if (!hasPermission(binding.value)) {
        el.parentNode?.removeChild(el);
      }
    },
  });
};
